import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CTA = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      data-testid="cta-section"
      className="py-24 md:py-32 relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#050505] to-[#0A0A0A]" />
      
      {/* Animated Background Gradient */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px]">
          <div className="absolute inset-0 bg-[#FF7A00]/10 rounded-full blur-[150px] animate-pulse" />
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center"
        >
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FF7A00]/10 border border-[#FF7A00]/20 mb-8"
          >
            <Sparkles className="w-4 h-4 text-[#FF7A00]" />
            <span className="text-sm text-[#FF7A00] font-medium">Rejoignez l'expérience</span>
          </motion.div>

          {/* Title */}
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6">
            <span className="text-white">{t('cta.title').split('?')[0]}</span>
            <span className="text-gradient">?</span>
          </h2>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-white/60 max-w-2xl mx-auto mb-10">
            {t('cta.subtitle')}
          </p>

          {/* CTA Button */}
          <motion.button
            onClick={scrollToContact}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
            data-testid="cta-main-btn"
            className="inline-flex items-center gap-3 px-10 py-5 rounded-full bg-[#FF7A00] text-white font-semibold text-lg shadow-[0_0_40px_rgba(255,122,0,0.4)] hover:shadow-[0_0_60px_rgba(255,122,0,0.6)] transition-all duration-300"
          >
            {t('cta.button')}
            <ArrowRight className="w-5 h-5" />
          </motion.button>

          {/* Trust Indicators */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="mt-12 flex flex-wrap items-center justify-center gap-8"
          >
            <div className="flex items-center gap-2 text-white/50">
              <span className="w-2 h-2 rounded-full bg-[#10B981]" />
              <span className="text-sm">Installation gratuite</span>
            </div>
            <div className="flex items-center gap-2 text-white/50">
              <span className="w-2 h-2 rounded-full bg-[#10B981]" />
              <span className="text-sm">Support 24/7</span>
            </div>
            <div className="flex items-center gap-2 text-white/50">
              <span className="w-2 h-2 rounded-full bg-[#10B981]" />
              <span className="text-sm">Sans engagement</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
